import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { Link, useParams,useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const EditTopic = () => {
  // const { id } = useParams(); // get topic_id from URL

  const [loading, setLoading] = useState(true);


  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const topicId = searchParams.get("id");

  const [topic, setTopic] = useState({});
  const [attachments, setAttachments] = useState([]);

  const [formData, setFormData] = useState({
    topic_name: "",
    description: "",
    youtube_link: "",
    attachments: [],
  });

  const [existingFiles, setExistingFiles] = useState([]);

  // ✅ FETCH TOPIC DETAILS
   useEffect(() => {
    fetchDetails();
  }, [topicId]);

  console.log(topicId);

  const fetchDetails = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/topic_details/${topicId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    console.log("API Response:", res.data);

    if (res.data.status === "success") {

      const topicData = res.data.data;

      setFormData({
        topic_name: topicData.topic_name || "",
        description: topicData.description || "",
        youtube_link: topicData.youtube_url || "",
        attachments: [],
      });

      setExistingFiles(topicData.attachments || []);
    } else {
      toast.error(res.data.message);
    }

    setLoading(false);

  } catch (err) {
    console.error(err);
    toast.error("Failed to load topic details");
    setLoading(false);
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, attachments: e.target.files });
  };

  const handleDelete = (fileId) => {
    // Optional: call API delete here
    setExistingFiles(existingFiles.filter((file) => file.id !== fileId));
  };

 const handleSubmit = async (e) => {

  e.preventDefault();

  const formDataObj = new FormData();

  formDataObj.append("topic_id", topicId); // ✅ for update
  formDataObj.append("topic_name", formData.topic_name);
  formDataObj.append("description", formData.description);
  formDataObj.append("youtube_link", formData.youtube_link);

  // Multiple files
  for (let i = 0; i < formData.attachments.length; i++) {
    formDataObj.append("attachement_file[]", formData.attachments[i]);
  }

  axios.post(
    API_BASE_URL + '/update_topic',
    formDataObj,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        // "Content-Type": "multipart/form-data"
      },
    }
  )
  .then(response => {

    var status = response.data.status;

    if (status === "success") {

      toast.success(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });

      // Optional: refresh topic details
      fetchDetails();

      // Clear only file input
      setFormData(prev => ({
        ...prev,
        attachments: []
      }));

    } 
    else if (status === "error") {

      toast.error(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });
    }

  })
  .catch(error => {

    toast.error(
      error.response?.data?.message || "Something went wrong",
      {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      }
    );

  });
};

  const getIcon = (filename) => {
    const ext = filename.split(".").pop().toLowerCase();

    if (ext === "pdf") return "/assets/pdf_icon.png";
    if (ext === "doc" || ext === "docx") return "/assets/word_icon.png";
    if (ext === "ppt" || ext === "pptx") return "/assets/ppt_icon.png";
    return "/icons/file_icon.png";
  };

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  return (
    <>
    <ToastContainer />
    <div className="container mt-4">
      <div className="card">
        <div className="card-header">
          <strong>Edit Topic</strong>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>

            <div className="form-group mb-3">
              <label>Topic Name *</label>
              <input
                type="text"
                name="topic_name"
                className="form-control"
                value={formData.topic_name}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              <label>Description</label>
              <textarea
                name="description"
                rows="6"
                className="form-control"
                value={formData.description}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              <label>Youtube Url</label>
              <input
                type="text"
                name="youtube_link"
                className="form-control"
                value={formData.youtube_link}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mb-3">
              <label>Attachment</label>
              <input
                type="file"
                multiple
                className="form-control"
                onChange={handleFileChange}
              />
            </div>

            {/* Existing Files */}
            <div className="row mb-3">
  {existingFiles.map((file) => (
    <div className="col-md-2 text-center" key={file.id}>
      <a
        href={`${API_BASE_URL}/uploads/topic/${file.attachement}`}
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={getIcon(file.attachement)}
          alt="icon"
          style={{ width: "60px", height: "60px" }}
        />
      </a>

      <button
        type="button"
        className="btn btn-sm btn-danger mt-2"
        onClick={() => handleDelete(file.id)}
      >
        ✕
      </button>
    </div>
  ))}
</div>

            <button type="submit" className="btn btn-primary">
              Update
            </button>

          </form>
        </div>
      </div>
    </div>
    </>
  );
};

export default EditTopic;